const FormRequestAction = {
  insert: "Adicionar o novo item desejado",
  update: "Alterar o item desejado",
  delete: "Deletar o item desejado",
};

export default FormRequestAction;
